<template>
    <div>
        <input type="file" ref="input" id="document" accept=".pdf" :name="inputName" style="display: none"
               @change="onFileSelection"/>
        <span class="upload" @click="showUpload">
            <button class="px-2 py-1 mr-2" type="button">Choose File</button>
            <small>{{ (name) ? name : 'No file chosen' }}</small>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            inputName: {
                default: () => {
                    return 'document'
                }
            },
            fileName: {
                default: () => {
                    return null
                }
            }
        },

        data() {
            return {
                name: this.fileName
            }
        },

        methods: {
            onFileSelection(event) {
                let files = event.target.files;

                if (files.length) {
                    this.name = files[0].name;
                }

                this.$emit('change', event)
            },

            showUpload() {
                const event = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': true
                });
                this.$refs.input.dispatchEvent(event)
            }
        }
    }
</script>
<style lang="scss">
    .upload {
        width: 100%;
        padding: .5rem;
        font-weight: 300;
        display: block;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-transition: background-color .5s ease;
        transition: background-color .5s ease;
        border-bottom: 1px solid transparent;
        background-color: rgba(37, 73, 156, .1);
        border-radius: 0;

        &:hover {
            background-color: rgba(37,73,156,.2);
        }
    }
</style>
